/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Filters_Sortclosingdateasc4Inputs */

const en_coinvestments_filters_sortclosingdateasc4 = /** @type {(inputs: Coinvestments_Filters_Sortclosingdateasc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closing date (soonest)`)
};

/**
* | output |
* | --- |
* | "Closing date (soonest)" |
*
* @param {Coinvestments_Filters_Sortclosingdateasc4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_filters_sortclosingdateasc4 = /** @type {((inputs?: Coinvestments_Filters_Sortclosingdateasc4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Filters_Sortclosingdateasc4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_filters_sortclosingdateasc4(inputs)
});
export { coinvestments_filters_sortclosingdateasc4 as "coInvestments_filters_sortClosingDateAsc" }